(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["freebie-auto-add-to-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__freebieBundleInit) return;
    window.__freebieBundleInit = true;

    var FREEBIE_PROPERTY = '_Freebie_for_variant';
    var CART_ADD_URL = /\/cart\/add(\.js)?(?:[?#]|$)/;

    /**
     * Free gifts for a variant, read from the JSON map rendered next to the variant picker.
     * Only gifts that were in stock when the page rendered are listed.
     */
    function getFreebieIds(variantId) {
      var maps = document.querySelectorAll('script[data-freebie-map]');
      for (var i = 0; i < maps.length; i++) {
        try {
          var ids = JSON.parse(maps[i].textContent)[String(variantId)];
          if (ids && ids.length) return ids;
        } catch (error) {
          // A malformed map must never block add to cart.
        }
      }
      return [];
    }

    /** Gift lines for one main line, skipping gifts the request already carries. */
    function buildGiftLines(mainId, quantity, existingIds) {
      return getFreebieIds(mainId)
        .filter(function (giftId) {
          return existingIds.indexOf(String(giftId)) === -1;
        })
        .map(function (giftId) {
          var properties = {};
          properties[FREEBIE_PROPERTY] = String(mainId);
          return { id: Number(giftId), quantity: quantity, properties: properties };
        });
    }

    /** JSON body: { items: [...] } or a single { id, quantity }. Returns the new body string, or null. */
    function mergeIntoJson(bodyText) {
      var payload = JSON.parse(bodyText);
      if (!payload || typeof payload !== 'object') return null;

      var items = payload.items;
      if (!Array.isArray(items)) {
        if (payload.id == null) return null;
        var line = {};
        ['id', 'quantity', 'properties', 'selling_plan'].forEach(function (key) {
          if (payload[key] !== undefined) line[key] = payload[key];
          delete payload[key];
        });
        items = [line];
      }

      var existingIds = items.map(function (item) {
        return String(item.id);
      });
      var gifts = [];
      items.forEach(function (item) {
        if (item.properties && item.properties[FREEBIE_PROPERTY]) return;
        gifts = gifts.concat(buildGiftLines(item.id, Number(item.quantity) || 1, existingIds));
      });
      if (!gifts.length) return null;

      payload.items = items.concat(gifts);
      return JSON.stringify(payload);
    }

    /** Theme form submit (FormData with a single `id`). Returns a new FormData, or null. */
    function mergeIntoFormData(formData) {
      var mainId = formData.get('id');
      if (!mainId) return null;
      var quantity = Number(formData.get('quantity')) || 1;

      var gifts = buildGiftLines(mainId, quantity, [String(mainId)]);
      if (!gifts.length) return null;

      var merged = new FormData();
      formData.forEach(function (value, key) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || /^properties\[/.test(key)) return;
        merged.append(key, value);
      });

      merged.append('items[0][id]', mainId);
      merged.append('items[0][quantity]', String(quantity));
      formData.forEach(function (value, key) {
        var property = key.match(/^properties\[(.*)\]$/);
        if (property) merged.append('items[0][properties][' + property[1] + ']', value);
        if (key === 'selling_plan') merged.append('items[0][selling_plan]', value);
      });

      gifts.forEach(function (gift, index) {
        var n = index + 1;
        merged.append('items[' + n + '][id]', String(gift.id));
        merged.append('items[' + n + '][quantity]', String(gift.quantity));
        merged.append('items[' + n + '][properties][' + FREEBIE_PROPERTY + ']', String(mainId));
      });
      return merged;
    }

    function mergeFreebies(body) {
      if (typeof body === 'string') return mergeIntoJson(body);
      if (typeof FormData !== 'undefined' && body instanceof FormData) return mergeIntoFormData(body);
      return null;
    }

    /**
     * Wraps fetch so every add-to-cart request (theme form, sticky bar, quick add, or the YourToken
     * widget) carries its free gifts inside the same /cart/add.js call. One request means one cart
     * write, so the main item and its gifts can no longer overwrite each other.
     */
    var originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input instanceof URL ? input.href : '';
        var method = ((init && init.method) || 'GET').toUpperCase();

        if (method === 'POST' && init && init.body && CART_ADD_URL.test(url)) {
          var mergedBody = mergeFreebies(init.body);
          if (mergedBody) {
            var mergedInit = Object.assign({}, init, { body: mergedBody });
            return originalFetch.call(this, input, mergedInit);
          }
        }
      } catch (error) {
        console.error('Freebie merge skipped:', error);
      }
      return originalFetch.apply(this, arguments);
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
